import { DeleteFromWishlistDetailsDto, DeleteFromWishlistDetailsDtoImpl } from './deletefromwishlistdetailsdto';
import { NoDataException } from '../../../../utils/exceptions/nodataexistsexception';

export class DeleteFromWishlistBuilder
{
    constructor(private deleteFromWishlistList: any)
    {
        if(deleteFromWishlistList.deletionStatusList === undefined)
        {
            throw new NoDataException("Delete Wishlist data doesnt exists");
        }
    }

    buildAll(): DeleteFromWishlistDetailsDto[]
    {
        return this.parseDeleteFromWishlistResponse();
    }
    
    private parseDeleteFromWishlistResponse(): DeleteFromWishlistDetailsDto[]
    {
        let listOfDeleteFromWishlist: DeleteFromWishlistDetailsDto[] = [];
        
        let deleteFromWishlistDetailsDto = null;
        this.deleteFromWishlistList.deletionStatusList.forEach((deletionDetailsItem: any) =>
        {
            deleteFromWishlistDetailsDto = new DeleteFromWishlistDetailsDtoImpl();
            deleteFromWishlistDetailsDto.setId(deletionDetailsItem.id);
            deleteFromWishlistDetailsDto.setStatus(deletionDetailsItem.status);

            listOfDeleteFromWishlist.push(deleteFromWishlistDetailsDto);
        });
        return listOfDeleteFromWishlist;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/wishlist/deletefromwishlist/deletefromwishlistbuilder.ts